import clsx from "clsx";
import React, { useEffect, useState } from "react";

export default function Pagination({ page, totalPages, onCallback }) {

    const buttonClass = 'hover:text-blue-500 focus:text-blue-500 p-1'

    return <ul className="flex gap-4 flex-between">
        {page > 1
            ? <button className={buttonClass} onClick={() => { onCallback(page - 1) }}>Previous</button>
            : null}
        {page != 1
            ? <button className={buttonClass} onClick={() => { onCallback(1) }}>1</button>
            : null}
        {page > 4
            ? <li>...</li>
            : null}
        {page - 2 > 1
            ? <button className={buttonClass} onClick={() => { onCallback(page - 2) }}>{page - 2}</button>
            : null}
        {page - 1 > 1
            ? <button className={buttonClass} onClick={() => { onCallback(page - 1) }}>{page - 1}</button>
            : null}
        <button className={clsx([buttonClass, 'text-blue-500'])}>{page}</button>
        {page + 1 < totalPages
            ? <button className={buttonClass} onClick={() => { onCallback(page + 1) }}>{page + 1}</button>
            : null}
        {page + 2 < totalPages
            ? <button className={buttonClass} onClick={() => { onCallback(page + 2) }}>{page + 2}</button>
            : null}
        {page + 3 < totalPages
            ? <li>...</li>
            : null}
        {page !== totalPages
            ? <button className={buttonClass} onClick={() => { onCallback(totalPages) }}>{totalPages}</button>
            : null}
        {page < totalPages
            ? <button className={buttonClass} onClick={() => { onCallback(page + 1) }}>Next</button>
            : null}
    </ul>
}